module.exports = __webpack_public_path__ + "img/xingqu.070a98a7.png";